import React, { Fragment } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import CollapsibleLinkRow from './CollapsibleLinkRow/CollapsibleLinkRow';
import LinkRow from './LinkRow/LinkRow';

import styles from './LinkGrid.scss';

function LinkGrid(props) {
    const {
        id,
        data = [],
        isActive = false,
        collapsible = false,
    } = props;

    return (
        <div
            className={classNames(
                styles.container,
                { [styles.isActive]: isActive },
            )}
            id={id}
        >
            {data.map((column, colIndex) => (
                <div
                    className={styles.column}
                    key={`column-${colIndex}`}
                >
                    {column.map((row, rowIndex) => (
                        <Fragment key={rowIndex}>
                            {collapsible
                                ? (
                                    <CollapsibleLinkRow
                                        data={row.data}
                                        header={row.header}
                                    />
                                )
                                : (
                                    <LinkRow data={row.data} />
                                )}
                        </Fragment>
                    ))}
                </div>
            ))}
        </div>
    );
}

LinkGrid.propTypes = {
    collapsible: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.array),
    id: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
};

export default LinkGrid;
